import React from 'react';
import './logo.css';
import { LogoImg } from './logo-img';

const Logo = ({ isPastSobreSection }) => {
  return (
    // <div className={`logo__container ${isPastSobreSection ? 'past-sobre' : ''}`}>
    //   <span className="logo__name">ANDRÉ PARREIRA</span>
    //   <span className="logo__specialty">PSICÓLOGO</span>
    // </div>
    <div className='psico__logo'>
      <img src={LogoImg} alt="André Parreira Psicólogo" />
    </div>
  );
};

export default Logo;
